<template>
  <a-spin :spinning="loading">
    <a-empty v-if="permissionName == ''" :description="$t('msg.I_K0004001_01')" style="margin: 10% 0px" />
    <div v-else class="calc-permission-wrapper">
      <div width="650" class="calc-permission-content">
        <p style="padding-left: 5px; margin-bottom: 8px; color: var(--color-grey)">
          <i
            class="mdi mdi-database-lock-outline"
            style="font-size: 16px; margin-right: 8px; position: relative; top: 1px; color: var(--color-orange)"
          />
          <span>具有此图标的页面，可以在图标的弹出框上设置数据权限</span>
        </p>
        <a-tree
          checkable
          @check="onCheck"
          :selectable="false"
          :checkedKeys="checkedKeys"
          :treeData="treeData"
          @expand="onExpand"
          :selectedKeys="selectedKeys"
          :expandedKeys="expandedKeysss"
          :checkStrictly="checkStrictly"
        >
          <span slot="hasDataRule" slot-scope="{ key, slotTitle, ruleFlag, dataFilter }">
            <span>{{ $getTextByLocale(slotTitle) }}</span>

            <a-popover
              trigger="hover"
              @visibleChange="(visible) => visibleChangeOutter(visible)"
              :destroyTooltipOnHide="true"
            >
              <template slot="title">
                {{ $t('disp.viewEditRangeSetting') }}
              </template>
              <template slot="content">
                <a-radio-group @change="changeRuleFlag(key)" :default-value="ruleFlag ? ruleFlag : defaultRuleFlag">
                  <div class="data-auth" style="margin-top: -6px">
                    <!--<a-radio :style="radioStyle" :value="'100000'">
                      <span class="anchor-auth100000"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'101000'">
                      <span class="anchor-auth101000"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'101010'">
                      <span class="anchor-auth101010"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'110000'">
                      <span class="anchor-auth110000"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'111000'">
                      <span class="anchor-auth111000"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'111010'">
                      <span class="anchor-auth111010"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'111100'">
                      <span class="anchor-auth111100"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'111110'">
                      <span class="anchor-auth111110"></span>
                    </a-radio>

                    <a-radio :style="radioStyle" :value="'111111'">
                      <span class="anchor-auth111111"></span>
                    </a-radio>-->

                    <a-radio :style="radioStyle" :value="'100000'">阅览个人</a-radio>
                    <a-radio :style="radioStyle" :value="'110000'">阅览个人 编辑个人</a-radio>
                    <a-divider style="margin: 10px 0"></a-divider>
                    <a-radio :style="radioStyle" :value="'101000'">阅览部门</a-radio>
                    <a-radio :style="radioStyle" :value="'111000'">阅览部门 编辑个人</a-radio>
                    <a-radio :style="radioStyle" :value="'111100'">阅览部门 编辑部门</a-radio>
                    <a-divider style="margin: 10px 0"></a-divider>
                    <a-radio :style="radioStyle" :value="'101010'">阅览公司</a-radio>
                    <a-radio :style="radioStyle" :value="'111010'">阅览公司 编辑个人</a-radio>
                    <a-radio :style="radioStyle" :value="'111110'">阅览公司 编辑部门</a-radio>
                    <a-radio :style="radioStyle" :value="'111111'">阅览公司 编辑公司</a-radio>
                  </div>
                </a-radio-group>
              </template>

              <template v-if="dataFilter && checkedKeys.includes(key)">
                <i
                  class="mdi mdi-database-lock-outline"
                  v-if="dataFilter"
                  style="font-size: 15px; color: var(--color-orange); vertical-align: bottom; margin: 0 5px 0 10px"
                />

                <span class="ruleFlagSummary">{{ getRuleFlagSummary(ruleFlag).split(';')[0] }}</span>
                <span class="ruleFlagSummary">{{ ' ' + getRuleFlagSummary(ruleFlag).split(';')[1] }}</span>
              </template>
              <!--<a-popover
                @visibleChange="(visible) => visibleChangeInner(visible, ruleFlag, 'anchor-auth')"
                :destroyTooltipOnHide="true"
              >
                <template slot="content">
                  <div class="data-auth" style="width: 540px; height: 16px; line-height: 1">
                    <span class="anchor-auth"></span>
                  </div>
                </template>

                <a-icon
                  v-if="ruleFlag && ruleFlag != '1111'"
                  type="eye-invisible"
                  theme="twoTone"
                  twoToneColor="#FAAD14"
                  style="
                    position: absolute;
                    margin-left: 20px;
                    margin-top: 4px;
                    animation: delayShow 1.6s both ease-in-out;
                    font-size: 16px;
                  "
                />
              </a-popover>-->
            </a-popover>
          </span>
        </a-tree>
      </div>
      <div class="drawer-bottom-button">
        <a-dropdown style="float: left" :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="switchCheckStrictly(1)">{{ $t('disp.tree.relation') }}</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">{{ $t('disp.tree.cancelRelation') }}</a-menu-item>
            <a-menu-item key="3" @click="checkALL">{{ $t('disp.tree.checkALL') }}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{ $t('disp.tree.cancelCheckALL') }}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{ $t('disp.tree.expandAll') }}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{ $t('disp.tree.closeAll') }}</a-menu-item>
          </a-menu>
          <a-button>
            {{ $t('disp.tree.operation') }}
            <a-icon type="up" />
          </a-button>
        </a-dropdown>
        <a-popconfirm :title="$t('msg.confirm.save')" @confirm="() => handleSubmit(true)">
          <a-button type="primary" icon="check">{{ $t('disp.btn.confirm') }}</a-button>
        </a-popconfirm>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { getAction, postAction } from '@/api/manage'
import { queryTreeListForRole } from '@/api/api'

export default {
  name: 'PermissionTreeModal',
  data() {
    return {
      roleId: '',
      records: [],
      queryParam: {},
      treeData: [],
      permissionName: '',
      defaultCheckedKeys: [],
      defaultRuleFlag: '100000',
      checkedKeys: [],
      expandedKeysss: [],
      allTreeKeys: [],
      autoExpandParent: true,
      checkStrictly: true,
      title: '角色权限配置',
      visible: false,
      loading: false,
      selectedKeys: [],
      leaf: {},
      radioStyle: {
        display: 'block',
        lineHeight: '30px',
        color: 'rgba(0, 0, 0, 0.85)',
      },
      url: {
        list: '/blaze-sys/k00/k0004/PermissionManage/queryGroupPermission',
        save: '/blaze-sys/k00/k0004/PermissionManage/save',
      },
    }
  },
  methods: {
    onClearSelected() {
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
    },
    onCheck(o) {
      if (this.checkStrictly) {
        this.checkedKeys = o.checked
      } else {
        this.checkedKeys = o
      }
    },
    close() {
      this.reset()
      this.$emit('close')
      this.visible = false
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys
      this.autoExpandParent = false
    },
    reset() {
      this.expandedKeysss = []
      this.checkedKeys = []
      this.defaultCheckedKeys = []
      this.loading = false
    },
    expandAll() {
      this.expandedKeysss = this.allTreeKeys
    },
    closeAll() {
      this.expandedKeysss = []
    },
    checkALL() {
      this.checkedKeys = this.allTreeKeys
    },
    cancelCheckALL() {
      this.checkedKeys = []
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false
      } else if (v == 2) {
        this.checkStrictly = true
      }
    },
    handleCancel() {
      this.close()
    },
    handleSubmit(exit) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      let that = this

      let permissionInfo = XEUtils.map(
        XEUtils.filter(
          XEUtils.toTreeArray(that.treeData),
          (item) =>
            that.checkedKeys.includes(item.key) &&
            (!item.alwaysShow || (item.ruleFlag && item.ruleFlag != that.defaultRuleFlag))
        ),
        (item) => item.key + ',' + item.ruleFlag
      )

      let params = {
        permissionName: that.records.permissionName,
        departId: that.records.departId,
        positionId: that.records.positionId,
        roleId: that.records.roleId,
        permissionInfo: permissionInfo.join(';'),
      }

      postAction(that.url.save, params)
        .then((res) => {
          if (res.success) {
            that.$message.success(that.$t(res.message))
            if (exit) {
              that.close()
            }
          } else {
            if (exit) {
              that.close()
            }
          }
          that.open(that.records)
        })
        .finally(() => {
          that.loading = false
        })
    },
    open(record) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      this.records = record
      this.permissionName = record.permissionName
      this.visible = true
      queryTreeListForRole(record).then((res) => {
        this.treeData = res.result.treeList
        this.allTreeKeys = res.result.ids

        var params = this.queryParam
        params.departId = record.departId
        params.positionId = record.positionId
        params.roleId = record.roleId

        getAction(this.url.list, params)
          .then((res) => {
            this.checkedKeys = [...res.result]
            this.defaultCheckedKeys = [...res.result]
            this.expandedKeysss = this.allTreeKeys

            this.disableAlwaysShow(this.treeData)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    disableAlwaysShow(target) {
      target.forEach((element) => {
        if (element.alwaysShow) {
          element.disableCheckbox = true
          this.checkedKeys.push(element.key)
          this.defaultCheckedKeys.push(element.key)
        }

        if (element.dataFilter && !element.ruleFlag) {
          element.ruleFlag = this.defaultRuleFlag
        }

        if (element.children && element.children.length > 0) {
          this.disableAlwaysShow(element.children)
        }
      })
    },
    changeRuleFlag(key) {
      this.findLeafByKey(this.treeData, key)
      if (this.leaf && this.leaf.key) {
        this.leaf.ruleFlag = event.target.value
      }
    },
    findLeafByKey(target, key) {
      target.forEach((element) => {
        if (element.key == key) {
          this.leaf = element
        } else {
          if (element.children && element.children.length > 0) {
            this.findLeafByKey(element.children, key)
          }
        }
      })
    },
    visibleChangeOutter(visible) {
      if (!visible) {
        return
      }

      this.visibleChangeInner(true, '100000', 'anchor-auth100000')
      this.visibleChangeInner(true, '101000', 'anchor-auth101000')
      this.visibleChangeInner(true, '101010', 'anchor-auth101010')
      this.visibleChangeInner(true, '110000', 'anchor-auth110000')
      this.visibleChangeInner(true, '111000', 'anchor-auth111000')
      this.visibleChangeInner(true, '111010', 'anchor-auth111010')
      this.visibleChangeInner(true, '111100', 'anchor-auth111100')
      this.visibleChangeInner(true, '111110', 'anchor-auth111110')
      this.visibleChangeInner(true, '111111', 'anchor-auth111111')
    },
    visibleChangeInner(visible, ruleFlag, anchor) {
      if (!visible) {
        return
      }

      setTimeout(() => {
        new Vue({
          el: '.' + anchor,
          render: function (h) {
            var viewSelf = ruleFlag.substring(0, 1) == '1' ? <a-icon type="check" /> : <a-icon type="close" />
            var editSelf = ruleFlag.substring(1, 2) == '1' ? <a-icon type="check" /> : <a-icon type="close" />
            var viewDepart = ruleFlag.substring(2, 3) == '1' ? <a-icon type="check" /> : <a-icon type="close" />
            var editDepart = ruleFlag.substring(3, 4) == '1' ? <a-icon type="check" /> : <a-icon type="close" />
            var viewCompany = ruleFlag.substring(4, 5) == '1' ? <a-icon type="check" /> : <a-icon type="close" />
            var editCompany = ruleFlag.substring(5, 6) == '1' ? <a-icon type="check" /> : <a-icon type="close" />

            return (
              <span>
                <span style="font-weight: bold; color: black;">个人：</span>
                <span>
                  <span>阅览</span>
                  {viewSelf}
                </span>
                <span>
                  <span>编辑</span>
                  {editSelf}
                </span>
                <span style="font-weight: bold; color: black;">部门：</span>
                <span>
                  <span>阅览</span>
                  {viewDepart}
                </span>
                <span>
                  <span>编辑</span>
                  {editDepart}
                </span>
                <span style="font-weight: bold; color: black;">公司：</span>
                <span>
                  <span>阅览</span>
                  {viewCompany}
                </span>
                <span>
                  <span>编辑</span>
                  {editCompany}
                </span>
              </span>
            )
          },
        })
      }, 1)
    },
    getRuleFlagSummary(ruleFlag) {
      if (!ruleFlag) {
        ruleFlag = this.defaultRuleFlag
      }

      var viewSelf = ruleFlag.substring(0, 1)
      var editSelf = ruleFlag.substring(1, 2)
      var viewDepart = ruleFlag.substring(2, 3)
      var editDepart = ruleFlag.substring(3, 4)
      var viewCompany = ruleFlag.substring(4, 5)
      var editCompany = ruleFlag.substring(5, 6)

      var summaryView = ''
      if (viewSelf == '1') {
        summaryView = '阅览个人'
      }
      if (viewDepart == '1') {
        summaryView = '阅览部门'
      }
      if (viewCompany == '1') {
        summaryView = '阅览公司'
      }

      var summaryEdit = ''
      if (editSelf == '1') {
        summaryEdit = '编辑个人'
      }
      if (editDepart == '1') {
        summaryEdit = '编辑部门'
      }
      if (editCompany == '1') {
        summaryEdit = '编辑公司'
      }

      return summaryView + ';' + summaryEdit
    },
  },
}
</script>
<style lang="less" scoped>
.drawer-bottom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 9px 16px 10px;
  text-align: right;
  left: 0;
  border-radius: 0 0 2px 2px;

  .ant-btn {
    margin-left: 8px;
    margin-right: 0px;
    margin-bottom: 0;
  }
}

.calc-permission-wrapper {
  height: calc(100vh - 158px);
  margin-top: -16px;
}

.calc-permission-content {
  height: calc(100vh - 210px);
  overflow: auto;
  // padding-bottom: 55px;
  padding-bottom: 10px;
  padding-left: 40px;
  padding-top: 16px;
}

.ruleFlagSummary {
  color: var(--color-grey);
  font-size: 13px;
  vertical-align: bottom;
  letter-spacing: 0px;
  border-bottom: 1px solid;
}
</style>
<style lang="less">
@keyframes scaleInOut {
  0% {
    opacity: 0.2;
    transform: scale(2);
  }

  /* 0.4 */
  25% {
    opacity: 1;
    transform: scale(1);
  }

  /* 0.8 */
  50% {
    opacity: 1;
    transform: scale(1);
  }

  51% {
    opacity: 0;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@keyframes delayShow {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  51% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

.data-auth {
  .anticon {
    margin-left: 5px;
    font-size: 12px;
  }

  & > .ant-radio-wrapper > span:last-child > span,
  & > span {
    & > span:nth-child(2),
    & > span:nth-child(3),
    & > span:nth-child(5),
    & > span:nth-child(6),
    & > span:nth-child(8) {
      margin-right: 15px;
    }

    & > span:nth-child(4),
    & > span:nth-child(7) {
      margin-left: 15px;
    }
  }

  .anticon-check {
    color: var(--color-green);
  }

  .anticon-close {
    color: var(--color-red);
  }
}
</style>
